import { useState } from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { categoryEntries } from "@/mocks/taxonomy";
import FeedbackModal from "@/pages/about/components/FeedbackModal";

export default function About() {
  const [showFeedback, setShowFeedback] = useState(false);

  usePageMeta(
    "关于我们 - 芒果视频",
    "了解芒果视频的定位与内容范围：我们聚合热门影视剧集、电影、综艺与短视频，为影视爱好者提供丰富优质的内容发现与浏览体验。",
    "关于芒果视频,芒果视频介绍,影视内容平台,联系我们,版权声明"
  );

  const values = [
    { icon: "ri-compass-3-line", title: "好内容，一眼可见", desc: "用清晰的分类与筛选，帮你把想看的内容快速挑出来。" },
    { icon: "ri-shield-check-line", title: "真实标注，不误导", desc: "所有演示数据均明确标注，不提供虚假的播放与下载承诺。" },
    { icon: "ri-refresh-line", title: "持续更新", desc: "跟进最新影视动态，让推荐列表始终新鲜。" },
  ];

  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-6 md:py-10 lg:px-10">
      <section className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/15 px-3 py-1 text-xs font-semibold text-primary-400">
          <i className="ri-tv-2-line"></i>
          关于我们
        </span>
        <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
          芒果视频，发现你的下一部好内容
        </h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
          芒果视频是一个面向影视内容爱好者的内容发现平台，专注于热门影视剧集、电影、综艺节目及短视频资源的整理与推荐。
          我们希望通过清晰的信息结构与顺畅的浏览体验，帮助追剧族、电影迷、综艺爱好者以及普通观众，更快地找到感兴趣的作品。
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link
            to="/category"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-apps-2-line text-lg"></i>
            开始浏览内容
          </Link>
          <button
            type="button"
            onClick={() => setShowFeedback(true)}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-400"
          >
            <i className="ri-chat-3-line text-lg"></i>
            提交反馈建议
          </button>
        </div>
      </section>

      <section className="mt-8">
        <h2 className="font-heading text-xl font-bold text-foreground-950">内容范围</h2>
        <p className="mt-1.5 text-sm text-foreground-600">覆盖四大内容形态，满足不同的观看需求。</p>
        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categoryEntries.map((entry) => (
            <Link
              key={entry.key}
              to={`/category?type=${encodeURIComponent(entry.type)}`}
              className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-500/60"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-400">
                {entry.name}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">{entry.desc}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="mt-8">
        <h2 className="font-heading text-xl font-bold text-foreground-950">我们的坚持</h2>
        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {values.map((item) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h2 className="font-heading text-lg font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            如果你对内容推荐、页面体验有任何想法，欢迎通过下方方式与我们取得联系。
          </p>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-center gap-2.5 text-foreground-700">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-200/40 text-foreground-800">
                <i className="ri-mail-line"></i>
              </span>
              support@mangovideo.example
            </li>
            <li className="flex items-center gap-2.5 text-foreground-700">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-200/40 text-foreground-800">
                <i className="ri-time-line"></i>
              </span>
              工作日 10:00 - 18:00
            </li>
          </ul>
          <button
            type="button"
            onClick={() => setShowFeedback(true)}
            className="mt-5 flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-feedback-line text-lg"></i>
            填写反馈表单
          </button>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
          <h2 className="font-heading text-lg font-bold text-foreground-950">用户须知与版权声明</h2>
          <ul className="mt-3 space-y-2.5 text-sm leading-relaxed text-foreground-600">
            <li className="flex gap-2">
              <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-400"></i>
              <span>本站为影视内容发现与浏览的演示站点，页面中的影视名称、封面、评分与演职人员均为虚构示例数据。</span>
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-400"></i>
              <span>本站不提供真实的视频播放、下载或在线观看服务，相关章节内容仅作文字说明演示。</span>
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-400"></i>
              <span>反馈表单用于收集用户体验建议，请勿提交敏感个人信息。</span>
            </li>
            <li className="flex gap-2">
              <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-400"></i>
              <span>本页面设计与示例内容仅用于技术演示，版权归原作者所有。</span>
            </li>
          </ul>
        </div>
      </section>

      {showFeedback && <FeedbackModal onClose={() => setShowFeedback(false)} />}
    </div>
  );
}